import {Component, ElementRef, ViewChild} from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {UtilProvider} from "../../providers/util/util";

/**
 * Generated class for the VideoPlayerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-video-player',
  templateUrl: 'video-player.html',
})
export class VideoPlayerPage {

  @ViewChild('video') video: ElementRef;

  public src: string;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public util: UtilProvider) {
    this.src = this.navParams.get('src');
    console.log("这是拿到的 url： " + this.src);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VideoPlayerPage');
  }

  playVideo() {
    this.video.nativeElement.play();
  }

}



// WEBPACK FOOTER //
// ./src/pages/video-player/video-player.ts